import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-enfaf-textarea-dark',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, FormsModule, TextFieldModule],
  templateUrl: './enfaf-textarea-dark.component.html',
  styleUrl: './enfaf-textarea-dark.component.scss'
})
export class EnfafTextareaDarkComponent {
  @Input() control!: any;
  @Input() placeholder!: string;
  @Input() rows: number = 3;
  @Input() cols: number = 1;
  @Input() autocomplete: 'off' | 'on' = 'off';
  @Input() disabled: boolean = false;
  @Input() label!: string;
  @Input() errorLabel!: string;
  @Input() maxlength?: number;
  /** Grows with content instead of staying fixed at `rows`, up to `maxRows` if set — opt-in so
   * every other (fixed-height) usage of this component is unaffected. */
  @Input() autosize: boolean = false;
  @Input() maxRows?: number;

  get hasValue() {
    return this.control && this.control.value !== null && this.control.value !== '';
  }
}
